export function calculaValorIpi(
  tabela_liq: number,
  val_ipi: number,
  per_ipi: number,
) {
  // eslint-disable-next-line prettier/prettier
  return val_ipi + ((tabela_liq * per_ipi) / 100);
}
